import { Component, Prop, Inject, Watch } from "vue-property-decorator";
import Vue from "vue";
import Vuetify from "vuetify";
import ModifVJsfInput from "@/shared/components/ModifVJsfInput/ModifVJsfInput.vue";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Http } from "@status/codes";
import store from "@/store";
import { mapGetters } from "vuex";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import {
  FORM_CONSTANTS,
  FORM_MESSAGES,
  VJSF_OPTIONS
} from "@/shared/constants/FormConstants";
import { FormSchema } from "@/shared/models/FormSchema";
import { SectionGroup } from "../../../../ServiceTemplate/models/SectionGroup";
import { FormsService } from "@/modules/Forms/services/FormService";
import FormRulePreview from "@/shared/components/FormModalViewer/FormRulePreview/FormRulePreview.vue";
import FormSummaryPreview from "@/shared/components/FormModalViewer/FormSummaryPreview/FormSummaryPreview.vue";
import vueDebounce from "vue-debounce";
import { FieldSummary } from "@/modules/FormTemplate/models/FieldSummary";
import { FormRule } from "@/modules/FormTemplate/models/FormRule";
import { FORM_TEMP_CONSTANTS } from "@/modules/FormTemplate/constants/FormTemplateConstants";
import {
  FORMS_ACCESS,
  FORMS_CONSTANTS
} from "@/modules/Forms/constants/FormsConstants";
import { FormTemplateData } from "@/modules/Forms/models/FormTemplateData";
import { Forms } from "@/modules/Forms/models/Forms";
import {
  SectionGroupDetail,
  SectionGroupDetailShort
} from "@/modules/ServiceTemplate/models/SectionGroupDetail";
import ModalTemplate from "@/shared/components/ModalTemplate/ModalTemplate.vue";
import { QuerySearch } from "@/modules/Forms/models/QuerySearch";
import {
  GENERAL_CONSTANTS,
  STORE_CONSTANTS
} from "@/shared/constants/GeneralConstants";
import FindFormTemplate from "@/shared/components/FindFormTemplate/FindFormTemplate.vue";
import { SECTION_SERVICE_FILL_CONSTANTS } from "./constants/SectionServiceFillConstants";
import { SERVICE_TYPES } from "@/modules/Services/constants/ServicesConstants";
import ShowIcon from "@/shared/components/ShowIcon/ShowIcon.vue";
import HtmlRenderFieldsForm from "@/shared/components/HtmlRenderFieldsForm/HtmlRenderFieldsForm.vue";
import { Utils } from "@/shared/utils/utils";
import { ListSchema } from "@/modules/List/models/ListSchema";
import { Option } from "@/modules/List/models/Option";
import { Field } from "@/modules/FormTemplate/models/Field";
import { FormulaField } from "@/shared/models/FormulaField";

Vue.use(vueDebounce, {
  defaultTime: "2000ms",
  listenTo: ["input", "click"]
});
Vue.use(Vuetify);
@Component({
  name: "SectionServiceFill",
  components: {
    ModifVJsfInput,
    FormRulePreview,
    FormSummaryPreview,
    FindFormTemplate,
    ModalTemplate,
    ShowIcon,
    HtmlRenderFieldsForm
  },
  computed: {
    ...mapGetters({
      refreshTemplateService: "getRefreshTemplateService"
    })
  }
})
export default class SectionServiceFill extends Vue {
  @Inject() formsService!: FormsService;

  @Prop() clusters!: SectionGroup[];
  @Prop() fillByStep!: boolean;
  @Prop() private serviceId!: string;
  @Prop() private userId!: string;
  @Prop() serviceCompleted!: boolean;
  @Prop() formReadOnly?: boolean;
  @Prop() private serviceTemplateVersion?: number;

  refreshTemplateService!: boolean;

  SEND_BTN = FORMS_CONSTANTS.BUTTON.SEND_FORM;
  SAVE_FORM = FORMS_CONSTANTS.BUTTON.SAVE_FORM;
  CANCEL_BUTTON = FORM_CONSTANTS.BUTTON.CANCEL;
  FORM_TEXT = FORMS_CONSTANTS.FORM_TEXT;
  secondaryButtonClass = STYLE_CLASSES.SECONDARY_BTN;
  cardClass = STYLE_CLASSES.CARD;
  primaryButtonClass = STYLE_CLASSES.PRIMARY_BTN;
  roundBtnClassPrimary = STYLE_CLASSES.PRIMARY_ROUND_BTN;
  modalText = FORM_MESSAGES.SAVE_MODAL.MESSAGE;
  modalTitle = FORM_MESSAGES.SAVE_MODAL.TITLE;
  COMPLETE_STATUS = FORM_CONSTANTS.STATE.COMPLETE;
  DELETED_STATUS = FORM_CONSTANTS.STATE.DELETED;
  CONST_LABELS = FORM_CONSTANTS.LABEL;
  text_delete = FORM_CONSTANTS.BUTTON.DELETE;
  ICONS = GENERAL_CONSTANTS.ICONS;
  customErrorMessages: { [key: string]: string } = {};
  stepperModel = 0;
  currentStep = 0;
  expasionPanel: number[] = [];

  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  model: any = {};
  options = VJSF_OPTIONS;
  vjsfKey = 0;
  schema: FormSchema = {
    type: "object",
    allOf: []
  };
  htmlSchema: FormSchema = {
    type: "object",
    allOf: []
  };
  formRules: FormRule[] = [];
  formSummary: FieldSummary[] = [];
  stepperForm = false;
  currentTemplate = -1;
  currentTemplateName = "";
  loadingData = false;
  formulaValue = "";
  modelChanged = false;
  /** Solo para remontar el/los widget(s) de tipo fórmula dentro de ModifVJsfInput. */
  formulaFieldRefreshKey = 0;
  dialogFormModal = false;
  formTemplate!: FormTemplateData;
  allowSend = false;
  icon = "";
  section = "";
  sectionIcon = "";
  sectionName = "";
  indexSection = 0;
  multiple = false;
  activeShowAddForm = false;
  serviceModelChanged = false;
  serviceCompleteValidation = false;
  disableSendForm = true;
  draft = false;
  formID = "";
  currentServiceId = "";
  partialSave = false;
  showForm = false;
  template: SectionGroupDetail = new SectionGroupDetail();
  indexTemplate = -1;
  indexContent = -1;
  htmlFieldsModel: Record<string, unknown> = {};

  @Watch("stepperModel")
  stepperModelChange() {
    this.expasionPanel = [];
    this.HideAddForm();
  }

  @Watch("clusters")
  setStep() {
    this.stepperModel = -1;
    this.$nextTick(() => {
      this.stepperModel = 0;
    });
  }

  setSendInfo(
    draft: boolean,
    form: string | undefined,
    section: string,
    sectionIcon: string,
    sectionName: string,
    indexSection: number,
    multiple?: boolean
  ) {
    this.draft = draft;
    this.formID = form ?? "";
    this.modalText = FORM_MESSAGES.SAVE_MODAL.MESSAGE;
    this.modalTitle = FORM_MESSAGES.SAVE_MODAL.TITLE;
    this.dialogFormModal = true;
    this.section = section;
    this.sectionIcon = sectionIcon;
    this.sectionName = sectionName;
    this.indexSection = indexSection;
    this.multiple = Boolean(multiple);
  }

  onModalDeleteDuplicate(index: number) {
    this.indexSection = index;
    this.modalText = FORM_MESSAGES.DELETE_MODAL.MESSAGE;
    this.modalTitle = FORM_MESSAGES.DELETE_MODAL.TITLE;
    this.dialogFormModal = true;
  }

  validate(
    index: string,
    paramsToSend: {
      draft: boolean;
      form: string | undefined;
      key: string;
      icon: string;
      name: string;
      index: number;
      multiple?: boolean;
    }
  ) {
    if (!this.stepperForm && !paramsToSend.draft) {
      (this.$refs["form-" + index] as any)[0].validate();

      Snackbar.popWarning(FORMS_CONSTANTS.SNACKBAR_MSG.EMPTY_FIELDS);
    } else {
      this.setSendInfo(
        paramsToSend.draft,
        paramsToSend.form,
        paramsToSend.key,
        paramsToSend.icon,
        paramsToSend.name,
        paramsToSend.index,
        paramsToSend.multiple
      );
    }
  }

  async handleModalAccept() {
    this.dialogFormModal = false;
    switch (this.modalTitle) {
      case FORM_MESSAGES.SAVE_MODAL.TITLE:
        await this.onSend();
        break;
      case FORM_MESSAGES.DELETE_MODAL.TITLE:
        await this.deleteDuplicate(this.indexSection);
        break;
    }
    this.currentTemplate = -1;
    this.currentTemplateName = "";
    this.currentStep = 0;
  }

  handleModalCancel() {
    this.dialogFormModal = false;
  }

  @Watch("refreshTemplateService")
  watchRefreshTemplateValidation() {
    return this.refreshTemplateService;
  }

  @Watch("expasionPanel")
  expasionPanelChange() {
    if (this.expasionPanel === undefined || this.expasionPanel.length === 0) {
      this.showForm = false;
      this.template = new SectionGroupDetail();
      this.indexTemplate = -1;
      this.indexContent = -1;
      return;
    }
    this.getFormTemplate(this.template, this.indexTemplate);
  }

  openPanel(
    template: SectionGroupDetail,
    indexTemplate: number,
    indexContent: number
  ) {
    this.template = template;
    this.indexTemplate = indexTemplate;
    this.indexContent = indexContent;
  }

  async getFormTemplate(FormTemplate: SectionGroupDetail, index: number) {
    const validateServiceTemplate = this.watchRefreshTemplateValidation();
    if (
      validateServiceTemplate &&
      FormTemplate.state?.toLocaleLowerCase() !=
        this.COMPLETE_STATUS.toLowerCase()
    ) {
      this.model = {};
      this.htmlFieldsModel = {};
      this.refreshServiceTemplateValidation();
      this.serviceCompleteValidation = false;
    } else if (
      FormTemplate.state?.toLocaleLowerCase() ==
      this.COMPLETE_STATUS.toLowerCase()
    ) {
      this.serviceCompleteValidation = true;
    } else {
      this.serviceCompleteValidation = false;
    }

    this.allowSend = false;
    this.loadingData = true;
    this.icon = FormTemplate.icon ?? "";
    try {
      this.schema = new FormSchema();
      this.htmlSchema = new FormSchema();
      const query: QuerySearch = {
        formTemplateId: FormTemplate.id,
        formId: FormTemplate.form,
        loadData: false,
        versionTemplate: FormTemplate.version
      };

      const responseData = await this.formsService.formServiceInformation(
        query
      );
      if (responseData.code === Http.Found && responseData.data != null) {
        const isCompletedTemplate =
          FormTemplate.state === this.COMPLETE_STATUS ||
          FormTemplate.state === this.DELETED_STATUS;
        const newSchema = responseData.data.schemaData?.schema ?? {
          type: "object",
          allOf: []
        };
        responseData.data.formTemplate.fields.forEach(field => {
          let isRequired = field.required;
          if (field.type === FORM_TEMP_CONSTANTS.FIELD_TYPE.FORMULA) {
            isRequired = false;
          }

          const indexAllOf = newSchema.allOf.findIndex(
            block =>
              block.properties != null &&
              Object.prototype.hasOwnProperty.call(block.properties, field.key)
          );
          if (!isRequired && indexAllOf !== -1) {
            newSchema.allOf[indexAllOf].required = [];
          }
        });
        this.schema = newSchema as FormSchema;
        if (
          isCompletedTemplate ||
          this.formReadOnly ||
          FormTemplate.state?.toLocaleLowerCase() ===
            this.COMPLETE_STATUS.toLowerCase()
        ) {
          this.setSchemaReadOnly();
        }
        const separatedSchema = Utils.splitFormSchemaByHtmlDisplay(newSchema);
        console.log("separatedSchema", separatedSchema);
        this.htmlSchema = separatedSchema.htmlSchema as FormSchema;
        this.schema = separatedSchema.vjsfSchema as FormSchema;

        this.formSummary = responseData.data.schemaData?.formSummary ?? [];
        this.formRules = responseData.data.schemaData?.formRules ?? [];
        this.vjsfKey++;
        this.showForm = true;
        this.currentTemplate = index;
        this.currentTemplateName = FormTemplate.name;
        this.currentStep = this.stepperModel;
        this.currentServiceId = this.serviceId;
        /*   this.model = {};
        this.htmlFieldsModel = {}; */
        if (responseData.data.form) {
          const { htmlFields, vjsfFields } = Utils.splitFormFieldsFromSchemas(
            responseData.data.form.fields as Record<string, unknown>,
            separatedSchema
          );
          console.log("htmlFields", htmlFields);
          console.log("vjsfFields", vjsfFields);
          this.model = Object.assign({}, vjsfFields);
          this.htmlFieldsModel = Object.assign({}, htmlFields);

          this.vjsfKey = 1 - this.vjsfKey;
        }
        this.formTemplate = responseData.data.formTemplate;
        this.allowSend = true;
        this.partialSave = responseData.data.formTemplate.partialSave ?? false;
      } else {
        this.formSummary = [];
        this.formRules = [];
        Snackbar.popInfo(responseData.message);
      }
      this.loadingData = false;
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${FORMS_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  sendToServiceOnChangeValidation(data: boolean) {
    store.commit(STORE_CONSTANTS.SERVICE_CHANGE_VALIDATION, data);
  }

  reloadData() {
    try {
      const items = (Array.isArray(this.schema.fields) &&
      this.schema.fields.length > 0
        ? this.schema.fields
        : this.formTemplate?.fields ?? []) as Array<FormulaField | Field>;
      const conditions = this.schema.conditions ? this.schema.conditions : [];
      let formulaOutputUpdated = false;

      if (
        Object.keys(this.model).length !== 0 &&
        !this.serviceCompleteValidation
      ) {
        this.serviceModelChanged = true;
        this.sendToServiceOnChangeValidation(this.serviceModelChanged);
      }

      items.forEach(field => {
        if (
          field.type === FORM_TEMP_CONSTANTS.FIELD_TYPE.FORMULA &&
          field.formula
        ) {
          this.formulaValue = field.formula.repeat(1);
          let fields = this.formulaValue.match(/\b[0-9A-Za-z_.-]{10}\b/g);
          if (fields !== null) {
            const uniqueSet = new Set(fields);
            fields = JSON.parse(JSON.stringify([...uniqueSet]));

            fields!.forEach(fieldString => {
              if (fieldString in this.model) {
                let newValue = "";
                let score;

                const existList = items.find(
                  item =>
                    item.key === fieldString &&
                    item.type === FORM_TEMP_CONSTANTS.FIELD_TYPE.LIST
                );

                if (existList != undefined) {
                  if (existList.options) {
                    score = existList.options.find(
                      (item: Option) => item.value === this.model[fieldString]
                    )?.score;
                  } else {
                    const oneOf = existList.schema.oneOf;
                    score = Array.isArray(oneOf)
                      ? oneOf.find(
                          (item: ListSchema) =>
                            item.const === this.model[fieldString]
                        )?.score
                      : undefined;
                  }
                }
                if ((score && Number(score)) || score == 0) {
                  newValue = score.toString();
                } else {
                  newValue = this.model[fieldString];
                }
                const regExp = new RegExp(fieldString, "g");
                this.formulaValue = this.formulaValue.replace(
                  regExp,
                  `${newValue}`
                );
              }
            });
            try {
              const result = eval(this.formulaValue);
              if (result && isFinite(result)) {
                Vue.set(this.model, field.key, result.toString());
                formulaOutputUpdated = true;
                this.modelChanged = true;
              }
            } catch (e) {
              delete this.model[field.key];
            }
          }
        }
      });

      conditions.forEach(condition => {
        if (condition.isArray && this.model[condition.key] != undefined) {
          this.model[condition.key].sort();
          this.modelChanged = true;
        }
      });

      if (this.modelChanged) {
        if (formulaOutputUpdated) {
          this.formulaFieldRefreshKey += 1;
        }
        this.modelChanged = false;
      }
    } catch (error) {
      console.error("Error reloading data", error);
    }
  }

  checkModel() {
    let modelSize = 0;
    /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
    const newFields: any = {};
    for (const property in this.model) {
      if (
        this.model[property] != undefined &&
        this.model[property].length !== 0
      ) {
        const fieldValue = this.formTemplate.fields.find(
          item => item.key === property
        );

        newFields[property] = {
          indicator: fieldValue?.indicator,
          title: fieldValue?.schema[property].title
        };

        if (
          fieldValue?.type === FORMS_CONSTANTS.FIELD_TYPE.LIST ||
          fieldValue?.visualElement === FORMS_CONSTANTS.FIELD.CHECKBOX
        ) {
          const fieldOptions = fieldValue?.options;
          switch (fieldValue?.visualElement) {
            case FORMS_CONSTANTS.FIELD.RADIO: {
              let listOption = fieldOptions?.find(
                item => item.value === this.model[property]
              );

              if (!listOption) {
                listOption = fieldOptions?.find(
                  item => item.title === this.model[property]
                );
              }

              newFields[property].titleSelectValue = [
                {
                  title: listOption?.title,
                  value: listOption?.value,
                  type: FORMS_CONSTANTS.FIELD.RADIO
                }
              ];
              newFields[property].scoreSelectValue = listOption?.score;
              newFields[property].value = [listOption?.value];
              newFields[property].listTemplate = fieldValue?.list;

              break;
            }
            case FORMS_CONSTANTS.FIELD.CHECKBOX: {
              const selectedValues = [];
              const titleItems = [];

              if (fieldValue?.type == FORMS_CONSTANTS.FIELD_TYPE.BASIC) {
                for (const checkItem in this.model[property]) {
                  selectedValues.push(this.model[property][checkItem]);
                }
                newFields[property].value = selectedValues;
              } else {
                for (const checkItem in this.model[property]) {
                  let listOption = fieldOptions?.find(
                    item => item.value === this.model[property][checkItem]
                  );

                  if (!listOption) {
                    listOption = fieldOptions?.find(
                      item => item.title === this.model[property][checkItem]
                    );
                  }

                  selectedValues.push(listOption?.value);
                  titleItems.push({
                    title: listOption?.title,
                    value: listOption?.value,
                    type: FORMS_CONSTANTS.FIELD.CHECKBOX
                  });

                  newFields[property].scoreSelectValue = listOption?.score;
                  newFields[property].titleSelectValue = titleItems;
                  newFields[property].value = selectedValues;
                }
                newFields[property].listTemplate = fieldValue?.list;

                if (this.model[property].length > 1)
                  newFields[property].scoreSelectValue = null;
              }
              break;
            }
            case FORMS_CONSTANTS.FIELD.SELECT: {
              let listOption = fieldOptions?.find(
                item => item.value === this.model[property]
              );

              if (!listOption) {
                listOption = fieldOptions?.find(
                  item => item.title === this.model[property]
                );
              }
              const listTitle = fieldValue?.schema[property].oneOf?.find(
                item => item.const === this.model[property]
              );

              newFields[property].titleSelectValue = [
                {
                  title: listTitle?.title,
                  value: listOption?.value,
                  type: FORMS_CONSTANTS.FIELD.SELECT
                }
              ];
              newFields[property].scoreSelectValue = listOption?.score;
              newFields[property].value = [listOption?.value];
              newFields[property].listTemplate = fieldValue?.list;

              break;
            }
          }
        } else {
          if (Array.isArray(this.model[property]))
            newFields[property].value = this.model[property];
          else newFields[property].value = [this.model[property]];
        }
        modelSize += 1;
      }
    }

    for (const property in this.htmlFieldsModel) {
      if (Object.prototype.hasOwnProperty.call(newFields, property)) {
        continue;
      }
      const raw = this.htmlFieldsModel[property];
      if (raw === undefined || raw === null) {
        continue;
      }
      if (typeof raw === "string" && raw.length === 0) {
        continue;
      }
      if (Array.isArray(raw) && raw.length === 0) {
        continue;
      }

      const fieldValue = this.formTemplate.fields.find(
        item => item.key === property
      );
      if (!fieldValue?.schema[property]) {
        continue;
      }

      newFields[property] = {
        indicator: fieldValue.indicator,
        title: fieldValue.schema[property].title
      };
      if (Array.isArray(raw)) {
        newFields[property].value = raw;
      } else {
        newFields[property].value = [raw];
      }
      modelSize += 1;
    }

    return { modelSize, newFields };
  }

  async onSend() {
    const modelChecked = this.checkModel();
    const newFields = modelChecked.newFields;
    const modelSize = modelChecked.modelSize;
    const form: Forms = {
      name: this.formTemplate.name,
      category: this.formTemplate.category,
      fields: newFields,
      formTemplate: this.formTemplate.id,
      versionTemplate: this.formTemplate.version,
      owner: this.userId,
      status:
        this.draft != true
          ? FORMS_CONSTANTS.STATE.COMPLETE
          : FORMS_CONSTANTS.STATE.INCOMPLETE,
      service: this.serviceId,
      section: this.section,
      icon: this.icon,
      multiple: this.multiple,
      sectionIcon: this.sectionIcon,
      sectionName: this.sectionName,
      formFlag: this.formID,
      draft: this.draft
    };
    try {
      if (modelSize !== 0) {
        const addResponse = await this.formsService.addServiceSectionsForm(
          form,
          this.serviceTemplateVersion
        );

        if (addResponse.code === Http.Ok && addResponse.data) {
          this.updateProgress(this.indexSection, addResponse.data);
          this.$emit(SECTION_SERVICE_FILL_CONSTANTS.EMIT.REFRESH_SERVICES);

          this.$emit(SECTION_SERVICE_FILL_CONSTANTS.EMIT.REFRESH_SERVICE_DATA, {
            serviceId: this.serviceId,
            type: SERVICE_TYPES.SECTIONS_KEY
          });
          this.model = {};
          Snackbar.popSuccess(addResponse.message);
          this.showForm = false;
          return;
        }
      }
      return Snackbar.popWarning(
        FORMS_CONSTANTS.SNACKBAR_MSG.EMPTY_FIELDS_DRAFT
      );
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${FORMS_ACCESS.POST}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  updateProgress(index: number, formId: string) {
    this.expasionPanel = [];
    Vue.set(
      this.clusters[index].formTemplates as SectionGroupDetail[],
      this.currentTemplate,
      {
        ...(this.clusters[index].formTemplates as SectionGroupDetail[])[
          this.currentTemplate
        ],
        state:
          this.draft != true
            ? FORMS_CONSTANTS.STATE.COMPLETE
            : FORMS_CONSTANTS.STATE.INCOMPLETE,
        form: formId
      }
    );

    let countFilled = 0;
    let countDeleted = 0;

    (this.clusters[index].formTemplates as SectionGroupDetail[]).forEach(f => {
      if (f.state && f.state === FORMS_CONSTANTS.STATE.COMPLETE) countFilled++;
      if (f.state && f.state === FORMS_CONSTANTS.STATE.DELETED) countDeleted++;
    });

    const newSectionProgress =
      (countFilled /
        ((this.clusters[index].formTemplates as SectionGroupDetail[]).length -
          countDeleted)) *
      100;
    Vue.set(this.clusters[index], "progress", newSectionProgress);
  }

  setSchemaReadOnly() {
    this.schema.allOf.forEach(field => {
      const keys = Object.keys(field["properties"]);
      if (field["properties"][keys[0]]["x-display"] == "textarea") {
        field["properties"][keys[0]]["x-props"]["readonly"] = true;
      } else {
        field["properties"][keys[0]].readOnly = true;
        field["properties"][keys[0]]["x-style"] = STYLE_CLASSES.READ_ONLY;
        if (field["then"]) {
          const keys = Object.keys(field["then"]["properties"]);
          keys.forEach(key => {
            if (field["then"]) {
              field["then"]["properties"][key].readOnly = true;
              field["then"]["properties"][key]["x-style"] =
                STYLE_CLASSES.READ_ONLY;
            }
          });
        }
      }
    });
  }

  showAddForm() {
    this.activeShowAddForm = true;
  }

  HideAddForm() {
    this.activeShowAddForm = false;
  }

  private addFormTemplate(
    formTemplateNew: SectionGroupDetail,
    formTempIndexNew?: number
  ) {
    const seccionSelect = this.clusters[this.stepperModel];
    formTempIndexNew = formTempIndexNew ?? seccionSelect.formTemplates!.length;
    formTemplateNew.additional = true;
    delete formTemplateNew.form;
    delete formTemplateNew.state;
    seccionSelect.formTemplates!.splice(formTempIndexNew, 0, formTemplateNew);
    this.calculateAverage();
  }

  insertFormTemplate(
    formTemplateNew: SectionGroupDetail | SectionGroupDetailShort
  ) {
    const seccionSelect = this.clusters[this.stepperModel];
    const formTempAll = (seccionSelect.formTemplates?.filter(
      formTemplateRef => formTemplateRef.id == formTemplateNew.id
    ) ?? []) as SectionGroupDetail[];

    let formTempIndexNew;

    if (formTempAll.length > 0) {
      if (!formTempAll[0].multiple) {
        Snackbar.popInfo(
          formTempAll[0].name + FORM_TEMP_CONSTANTS.LABEL.FORM_MULTIPLES_NOT
        );
        return;
      }
      formTempIndexNew =
        seccionSelect.formTemplates?.findIndex(
          formTemplateRef => formTemplateRef.id == formTemplateNew.id
        )! + formTempAll.length;
    }

    this.addFormTemplate(
      { ...formTemplateNew } as SectionGroupDetail,
      formTempIndexNew
    );
    this.HideAddForm();
  }

  isFirst(index: number, id: string) {
    const seccionSelect = this.clusters[this.stepperModel];
    const formTempIndexNew = seccionSelect?.formTemplates?.findIndex(
      formTemplateRef => formTemplateRef.id == id
    );
    return formTempIndexNew == index;
  }

  async deleteDuplicate(index: number) {
    const seccionSelect = this.clusters[this.stepperModel];
    try {
      const form = (seccionSelect.formTemplates![index] as SectionGroupDetail)
        ?.form;

      if (form) {
        const addResponse = await this.formsService.deleteServiceSectionsForm(
          form
        );
        if (addResponse.code !== Http.Ok) {
          throw new Error(addResponse.message);
        }
      }
      Snackbar.popSuccess(FORM_MESSAGES.DELETE);
      this.$emit(SECTION_SERVICE_FILL_CONSTANTS.EMIT.REFRESH_SERVICES);
      this.model = {};
      this.htmlFieldsModel = {};
      this.showForm = false;
      seccionSelect.formTemplates!.splice(index, 1);
      this.calculateAverage();
    } catch (e) {
      Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  calculateAverage() {
    const seccionSelect = this.clusters[this.stepperModel];
    const formTemplates = seccionSelect.formTemplates as SectionGroupDetail[];
    const total = formTemplates?.length;
    const fill = formTemplates?.filter(formTemplateRef => formTemplateRef.form)
      .length;
    seccionSelect.progress = (fill * 100) / total;
  }

  refreshServiceTemplateValidation() {
    store.commit(STORE_CONSTANTS.REFRESH_SERVICE_TEMPLATE, false);
  }

  onRequiredComplete(isValid: boolean) {
    this.disableSendForm = !isValid;
  }
}
